// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCdDDKjxaTNqvQ1_wB5Mhe9I7ebK_xev5M",
  authDomain: "deporteselite-prod.firebaseapp.com",
  projectId: "deporteselite-prod",
  storageBucket: "deporteselite-prod.firebasestorage.app",
  messagingSenderId: "617343101007",
  appId: "1:617343101007:web:2d21613d2b0d7a5cc3223a",
  measurementId: "G-B6RZ49GESP"
  },
  apiUrl: 'https://auxiliar.deporteselite.com/api',
  pagosApiUrl: 'https://auxiliar.deporteselite.com/api/pagos.php'
};